import { Grid } from '@mui/material'

import AutoComplete from './AutoComplete'

const GridAutoComplete = ({
  label,
  field,
  value,
  options,
  getOptionLabel,
  onChange = () => {},
  md = 6,
  blurOnSelect,
  multiple,
  mode = 'update',
}) => (
  <Grid size={{ xs: 12, md }}>
    <center>
      <AutoComplete
        label={label}
        value={value}
        options={options}
        getOptionLabel={getOptionLabel}
        onChange={i => onChange(field, i)}
        blurOnSelect={blurOnSelect}
        multiple={multiple}
        mode={mode}
      />
    </center>
  </Grid>
)

export default GridAutoComplete
